// Utility function for tracking button clicks

export const trackClick = async (action: 'call_now' | 'book_trailer', component?: string) => {
  try {
    await fetch('/api/tracking', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action,
        component,
        page: window.location.pathname,
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
      }),
    });
  } catch (error) {
    // Silently fail - don't disrupt user experience
    console.log('Tracking failed:', error);
  }
};